﻿import { Carousel } from '@fancyapps/ui'
import { Autoplay } from '@fancyapps/ui/dist/carousel.autoplay.esm.js';

const touchEvent = 'ontouchstart' in window ? 'touchstart' : 'click'

interface Options {
    [key: string]: any
}

const initSlideshowBlock = () => {
    const slideshowContainer = document.querySelector('.block__slideshow')
    const autoplay = slideshowContainer.getAttribute('data-autoplay').includes('True')
    const autoplaySpeed = parseInt(slideshowContainer.getAttribute('data-speed')) * 1000
    const navigationDots = Array.from(document.querySelectorAll('.navigation--dots__dot'))

    const options: Options = {
        'slidesPerPage': 1,
        Dots: false,
        Navigation: false,
        friction: 0,
        on: {
            change: (carousel: any, to: HTMLElement) => {
                let activeIndex = carousel.page //Ignore error, this property does exist

                navigationDots.forEach(dot => {
                    if (dot.classList.contains('active')) {
                        dot.classList.remove('active')
                    }
                    if (dot.getAttribute('carousel-data-for') == activeIndex) {
                        dot.classList.add('active')
                    }
                })
            }
        }
    }

    if (autoplay) {
        Carousel.Plugins.Autoplay = Autoplay
        options.Autoplay = { timeout: autoplaySpeed }
    }

    const slideshow = new Carousel(document.querySelector('.carousel'), options)

    // Navigation
    const prevButton = document.querySelectorAll('.navigation--prev')[0]
    const nextButton = document.querySelectorAll('.navigation--next')[0]

    prevButton?.addEventListener(touchEvent, function handleClick(event) {
        slideshow.slidePrev()
    })
    nextButton?.addEventListener(touchEvent, function handleClick(event) {
        slideshow.slideNext()
    })

    for (const dot of navigationDots) {
        dot.addEventListener(touchEvent, function handleClick() {
            let dotIndex = parseInt(dot.getAttribute('carousel-data-for'))
            slideshow.slideTo(dotIndex)
        })
    }
}

const initImageTextBlockSlideshow = () => {
    const slideshows = document.querySelectorAll('.image-text-block__slideshow') as NodeListOf<HTMLElement>
    const options:Options = {
        slidesPerPage: 1,
        adaptiveHeight: true,
        Navigation: false,
        Dots: false,
    }
    slideshows.forEach(slideshow => {
        const carousel = new Carousel(slideshow.querySelector('.carousel'), options)

        const prevButton = slideshow.querySelector('.prev') as HTMLButtonElement
        const nextButton = slideshow.querySelector('.next') as HTMLButtonElement

        prevButton?.addEventListener('click', () => { carousel.slidePrev() })
        nextButton?.addEventListener('click', () => { carousel.slideNext() })
    })
}

export function initSlideshow() {
    if (document.getElementsByClassName('block__slideshow').length > 0 && document.getElementsByClassName('carousel').length > 0) {
        initSlideshowBlock()
    }

    if (document.querySelectorAll('.image-text-block__slideshow').length > 0)
    {
        initImageTextBlockSlideshow()
    }
}